import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ResetPasswordPage } from '@features/auth/reset-password.tsx';

const searchSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute('/reset-password')({
  component: RouteComponent,
  validateSearch: search => searchSchema.parse(search),
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return <ResetPasswordPage token={token} />;
}
